import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { JobsDashboardTable } from "./JobsDashboardTable";

interface Props {
	setLoading: (loading: boolean) => void;
}

const JobsDashboardWithLocalizationProvider = (props: Props) => {
	return (
		<LocalizationProvider dateAdapter={AdapterDayjs}>
			<JobsDashboardTable setLoading={props.setLoading} />
		</LocalizationProvider>
	);
};

export default JobsDashboardWithLocalizationProvider;
